import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ToastModule } from '@shared/components/toast';

import { DynamicReportGeneralCreateComponent } from './dynamic-report-general-create.component';
import { DynamicReportGeneralFormModule } from '../dynamic-report-general-form/dynamic-report-general-form.module';
import { DynamicReportGeneralCreateRoutingModule } from './dynamic-report-general-create-routing.module';
import { PermissionModule } from '@shared/permission';
import { DynamicReportGeneralPreviewModule } from '../dynamic-report-general-preview/dynamic-report-general-preview.module';

const angularMaterialModules = [
  MatIconModule,
  MatButtonModule
];



@NgModule({
  declarations: [
    DynamicReportGeneralCreateComponent
  ],
  imports: [
    CommonModule,
    ...angularMaterialModules,
    DynamicReportGeneralCreateRoutingModule,
    DynamicReportGeneralFormModule,
    PermissionModule,
    ToastModule,
    DynamicReportGeneralPreviewModule
  ]
})
export class DynamicReportGeneralCreateModule { }
